import React, { useState } from "react"
import ClassNames from "classnames"
import { get, pick } from "lodash"
import { useSelector, TypedUseSelectorHook } from "react-redux"

import { chartReducer, chartReducerPropety } from "redux/ducks/Chart"
import { open_chart } from "../../../utils/util"

export const Btn = (props: {
  className?: string
  name?: string
  onClick?: Function
}) => {
  return (
    <div
      className={ClassNames("btn", props.className)}
      onClick={() => props.onClick && props.onClick()}
    >
      {props.name}
    </div>
  )
}

export const ChartBtn = (props: {
  className?: string
  onClick?: Function
  canvasId?: string
}) => {
  const symbolDetail: chartReducerPropety = useSelector(
    (state: { chart: chartReducer }) => {
      return state.chart[props.canvasId]
    }
  )
  const param = pick(get(symbolDetail, "symbol"), [
    "SecurityType",
    "Exchange",
    "Symbol",
  ])
  return (
    <div
      className={ClassNames("btn btn-primary btn-chart icon-ripple")}
      onClick={() =>
        props.onClick && !!symbolDetail
          ? props.onClick()
          : open_chart(param, symbolDetail)
      }
      title={"テクニカルチャート"}
    >
      {/*<i className="material-icons">show_chart</i>*/}
      <span className="material-icons-svg">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="#f7f6e8"
          width="18px"
          height="18px"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
        </svg>
      </span>
    </div>
  )
}

type SwitchBtnType = {
  names: [string, string]
  onClick?: Function
}
export const SwitchBtn: React.FC<SwitchBtnType> = props => {
  const [isActive, changeActive] = useState<boolean>(true)
  return (
    <div
      className={ClassNames("btn-switch", { active: isActive })}
      onClick={e => {
        changeActive(!isActive)
        props.onClick && props.onClick(e)
      }}
    >
      <div className="btn-switch-names">
        {props.names.map((str: string, i: number) => (
          <span key={i}>{str}</span>
        ))}
      </div>
    </div>
  )
}

type HamburgerButtonType = {
  isClose: boolean
  onClick: Function
}

export const HamburgerButton: React.FC<HamburgerButtonType> = props => (
  <div
    className={ClassNames("btn-hamburger", { "is-close": props.isClose })}
    onClick={() => props.onClick()}
  >
    <span />
  </div>
)
